<template>
	<BaseLayout :footer-full="true">
		<DisclosuresFull />
	</BaseLayout>
</template>

<script setup lang="ts">
import DisclosuresFull from '@components/legal/disclosures-full.vue';
import { useHead } from '@unhead/vue';

function setup(): void {
	useHead({
		title: 'Full Disclosure',
		meta: [
			{ property: 'og:title', content: 'Full Disclosure' },
			{ name: 'description', content: 'Full Disclosure' },
			{ property: 'og:description', content: 'Full Disclosure' }
		]
	});
}
setup();
</script>
